"use strict";
exports.__esModule = true;
exports.initAccount = void 0;
var bignumber_js_1 = require("bignumber.js");
function initAccount(r) {
    var _a, _b;
    r.algorandResources = {
        rewards: new bignumber_js_1.BigNumber(0),
        nbAssets: (_b = (_a = r.subAccounts) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0
    };
}
exports.initAccount = initAccount;
//# sourceMappingURL=initAccount.js.map